/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import {
  Avatar,
  Box,
  Collapse,
  Divider,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  ExpandLess,
  ExpandMore,
  Task,
} from '@mui/icons-material';
import { buildPlanningDayOverviewData } from '../../buildOverviewGrid';
import Horse from '../../../../../Horse';
import User from '../../../../../User';
import { primary } from '../../../../../../utils/brandColors';

export const PlanningModeTaskOverview = () => {
  const [planningOverviewData, setPlanningOverviewData] = React.useState({})
  const [openTaskId, setOpenTaskId] = React.useState(null)
  const [openUserId, setOpenUserId] = React.useState(null)
  const [openHorsesMissingTasks, setOpenHorsesMissingTasks] = React.useState(false)
  // const [activeByTaskIndex, setActiveByTaskIndex] = React.useState(-1);

  const tasks = useSelector((state) => state.board.tasks);
  const events = useSelector((state) => state.board.events);
  const planningModeDay = useSelector((state) => state.board.planningDay);
  const barnHorses = useSelector((state) => state.board.barnHorses);
  const barnUsers = useSelector((state) => state.barn.barnUsers);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap)
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const allEventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const eventTemplatesMap = Object.assign({}, ...(allEventTemplates.map((i) => ({ [i.id]: i }))))

  React.useEffect(() => {
    if (planningModeDay) {
      const start = moment(new Date(parseInt(planningModeDay, 10))).startOf('day').toDate().getTime();
      const end = moment(new Date(parseInt(planningModeDay, 10))).endOf('day').toDate().getTime();
      setPlanningOverviewData(buildPlanningDayOverviewData(
        moment(planningModeDay).startOf('day'),
        moment(planningModeDay).endOf('day'),
        events.filter((e) => e.start.getTime() >= start && e.end.getTime() <= end && !e.barnTask),
        tasks.filter((t) => {
          const startDate = new Date(t.startDate); return startDate.getTime() >= start && startDate.getTime() <= end
            && !t.tags.find((tt) => tt.id !== selectedBarn.barnMetadata.barnTaskTypeTagId);
        }),
        barnUsers.filter((bu) => bu.roles.indexOf('staff') >= 0 || bu.roles.indexOf('admin') >= 0 || bu.roles.indexOf('owner') >= 0),
        barnHorses.map((bh) => bh.pingumTagId),
        barnUsersMap,
        barnHorsesMap,
      ))
    } else {
      setPlanningOverviewData({})
    }
  }, [events, tasks, planningModeDay]);

  // const renderPieChartLael = ({
  //   taskName,
  //   value,
  // }) => `${taskName || 'Unknown Type'} (${value})`

  return (
    <Box
      sx={{
        flex: 1,
        height: '100%',
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {
            planningOverviewData.horsesMissingTask && (
              <Box sx={{ width: '100%' }}>
                <Typography variant="subtitle2" textAlign="left" fontWeight={600}>{barnHorses.length - planningOverviewData.horsesMissingTask.length} of {barnHorses.length} Horses with Tasks</Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => setOpenHorsesMissingTasks(!openHorsesMissingTasks)}
                >
                  <Box
                    sx={{
                      width: '100%',
                      mr: 1,
                    }}
                  >
                    <LinearProgress variant="determinate" value={-Math.round(((planningOverviewData.horsesMissingTask.length - barnHorses.length) / barnHorses.length) * 100)} />
                  </Box>
                  <Box
                    sx={{
                      minWidth: 60,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography variant="body2" color="text.secondary">{`${-Math.round(
                      ((planningOverviewData.horsesMissingTask.length - barnHorses.length) / barnHorses.length) * 100,
                    )}%`}
                    </Typography>

                    {openHorsesMissingTasks
                      ? <ExpandLess />
                      : <ExpandMore />}
                  </Box>
                </Box>

                <Collapse in={openHorsesMissingTasks} timeout="auto" unmountOnExit>
                  <Typography color="warning" gutterBottom>{planningOverviewData.horsesMissingTask.length > 0
                    ? 'Horses without a task'
                    : 'Every horse has at least 1 task'}
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      flexWrap: 'wrap',
                    }}
                  >
                    {
                      planningOverviewData.horsesMissingTask.filter((h) => !!barnHorsesMap[h]).map((h) => (<Horse key={`horse-missing-task-${h}`} chip horse={barnHorsesMap[h][0].horse} />))
                    }
                  </Box>
                </Collapse>
              </Box>
            )
          }
        </Grid>
        <Grid item xs={12}><Divider /></Grid>
        {
          planningOverviewData.tasksByType && Object.keys(planningOverviewData.tasksByType).length > 0 && (

            <Grid item xs={12}>
              <Typography variant="subtitle2" textAlign="left" fontWeight={600}>Task by Horse</Typography>
              {
                Object.keys(planningOverviewData.tasksByType)
                  .sort((a, b) => planningOverviewData.tasksByType[b].length - planningOverviewData.tasksByType[a].length)
                  .map((taskId) => {
                    const eventTemplate = eventTemplatesMap[`${taskId}`]
                      ? eventTemplatesMap[`${taskId}`]
                      : null;

                    return (
                      <Box key={`tasks-by-horse-${taskId}`}>
                        <ListItemButton
                          sx={{ padding: 0 }}
                          onClick={() => {
                            setOpenTaskId(openTaskId === taskId
                              ? null
                              : taskId)
                          }}
                        >
                          {
                            eventTemplate && (
                              <ListItemAvatar>
                                <Avatar sx={{ backgroundColor: eventTemplate.eventDataDefaultValues.calendarDisplayColor || primary[500] }}>
                                  <Task sx={{ color: 'white' }} />
                                </Avatar>
                              </ListItemAvatar>
                            )
                          }
                          <ListItemText
                            primary={eventTemplate
                              ? eventTemplate.name
                              : 'Unknown Task'}
                            secondary={`${(planningOverviewData.tasksByType[taskId] && planningOverviewData.tasksByType[taskId].length) || 0} Horse${planningOverviewData.tasksByType[taskId].length > 1
                              ? 's'
                              : ''}`}
                          />
                          {openTaskId === taskId
                            ? <ExpandLess />
                            : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openTaskId === taskId} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding>
                            {
                              planningOverviewData.tasksByType[taskId]
                                .sort((a, b) => -((b.barnHorse && b.barnHorse.horse.name) || '').localeCompare((a.barnHorse && a.barnHorse.horse.name) || ''))
                                .map((taskHorse) => {
                                  const { barnHorse } = taskHorse
                                  return (

                                    <ListItem dense key={`task-horse-${taskId}-${taskHorse.horseId}`} divider>
                                      {barnHorse && <ListItemAvatar><Horse horse={barnHorse.horse} chip /></ListItemAvatar>}
                                      <ListItemText />
                                      {taskHorse.assignments
                                        ? (
                                          <Box
                                            sx={{
                                              maxWidth: taskHorse.length > 1
                                                ? 165
                                                : '100%',
                                              overflow: 'hidden',
                                            }}
                                          >{taskHorse.assignments.map((u) => (<User key={`task-horse-${taskId}-${taskHorse.horseId}-${u.id}`} user={u} chip disableGutters />))}
                                          </Box>
                                        )
                                        : 'No Assignment'}
                                    </ListItem>
                                  )
                                })
                            }
                          </List>
                        </Collapse>
                      </Box>
                    )
                  })
              }
            </Grid>
          )
        }{
          planningOverviewData.staffTasks && Object.keys(planningOverviewData.staffTasks)
            .filter((user) => planningOverviewData.staffTasks[user].length > 0).length > 0
          && (
            <Grid item xs={12}><Divider /></Grid>
          )
        }
        {
          planningOverviewData.staffTasks && Object.keys(planningOverviewData.staffTasks)
            .filter((user) => planningOverviewData.staffTasks[user].length > 0).length > 0
          && (
            <Grid item xs={12}>
              <Typography variant="subtitle2" textAlign="left" fontWeight={600}>Staff by Task</Typography>
              {
                Object.keys(planningOverviewData.staffTasks)
                  .filter((user) => planningOverviewData.staffTasks[user].length > 0)
                  .sort((a, b) => planningOverviewData.staffTasks[b].length - planningOverviewData.staffTasks[a].length)
                  .map((userId) => {
                    const barnUser = barnUsersMap[userId]
                      ? barnUsersMap[userId][0]
                      : null;
                    return (
                      <Box key={`tasks-by-staff-${userId}`}>
                        <ListItemButton
                          sx={{ padding: 0 }}
                          onClick={() => {
                            setOpenUserId(openUserId === userId
                              ? null
                              : userId)
                          }}
                        >
                          {
                            barnUser && (
                              <ListItemAvatar>
                                <User mini user={barnUser} />
                              </ListItemAvatar>
                            )
                          }
                          <ListItemText
                            primary={barnUser
                              ? barnUser.userFullName
                              : 'Unknown Staff'}
                            secondary={`${(planningOverviewData.staffTasks[userId] && planningOverviewData.staffTasks[userId].length) || 0} Task${planningOverviewData.staffTasks[userId].length > 1
                              ? 's'
                              : ''}`}
                          />
                          {openUserId === userId
                            ? <ExpandLess />
                            : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={openUserId === userId} timeout="auto" unmountOnExit>
                          <List component="div" disablePadding>
                            {
                              planningOverviewData.staffTasks[userId]
                                .sort((a, b) => -((b.barnHorse && b.barnHorse.horse.name) || '').localeCompare((a.barnHorse && a.barnHorse.horse.name) || ''))
                                .map((taskHorse) => {
                                  const { barnHorse } = taskHorse
                                  return (

                                    <ListItem dense key={`task-user-${userId}-${taskHorse.horseId}`} divider>
                                      <ListItemText
                                        primary={taskHorse.task.name}
                                        sx={{
                                          borderTopLeftRadius: 4,
                                          borderBottomLeftRadius: 4,
                                          paddingLeft: 1,
                                          borderLeft: `6px solid ${taskHorse.task.eventDataDefaultValues.calendarDisplayColor || primary[500]}`,
                                        }}
                                      />
                                      <Horse horse={barnHorse.horse} chip />
                                    </ListItem>
                                  )
                                })
                            }
                          </List>
                        </Collapse>
                      </Box>
                    )
                  })
              }
            </Grid>
          )
        }
      </Grid>
    </Box>
  )
}
